<template>
  <div class="stockwrap">
    <!--startprint-->
    <div v-bind="stockData" class="stockMain" id="printBox">
      <div class="stockMain title" id="printTitle">采购退货单</div>
      <div class="stockMain content">
        <ul>
          <li>
            <div>采购退货单编号: {{stockData.exitNumber}}</div>
          </li>
          <li>
            <div>采购出库单编号: {{stockData.purchaseNumber}}</div>
          </li>
          <li>
            <div>退货商户名称: {{stockData.shopName}}</div>
          </li>
          <li>
            <div>法人姓名: {{stockData.name}}</div>
          </li>
          <li>
            <div>店铺地址: {{stockData.address}}</div>
          </li>
          <li>
            <div>采购时间: {{handleFormatterDateToUTC(stockData.purchaseTime)}}</div>
          </li>
          <li>
            <div>申请退货时间: {{handleFormatterDateToUTC(stockData.applicantExitTime)}}</div>
          </li>
          <li>
            <avue-crud
              :option="tableOption"
              :data="tableData"
              :table-loading="tableLoading"
              ref="crud"
            ></avue-crud>
          </li>
          <li>
            <div>退货商品数量共计: {{stockData.totalNumber}}</div>
          </li>
          <li>
            <div>采购订单金额: {{stockData.totalMoney}}元</div>
          </li>
          <li>
            <div>退货订单金额: {{stockData.exitMoney}}元</div>
          </li>
          <li>
            <div>退货状态: {{stockData.status == 'WAIT_AUDIT' ? '待审核' : (stockData.status == 'RETURNED' ? '已退回' : '已完成')}}</div>
          </li>
          <li v-if="stockData.status == 'RETURNED'">
            <div>退回时间: {{handleFormatterDateToUTC(stockData.applicantExitTime)}}</div>
          </li>
          <li v-if="stockData.status == 'RETURNED'">
            <div>退回原因: {{stockData.returnReason}}</div>
          </li>
          <li v-if="stockData.exitGoodsTime">
            <div>退货时间: {{handleFormatterDateToUTC(stockData.exitGoodsTime)}}</div>
          </li>
        </ul>
      </div>
      <div class="stockMain btn" id="noprint">
        <el-button @click="doPdf">下载PDF</el-button>
        <el-button @click="doPrint">打印</el-button>
        <el-button v-if="stockData.status == 'WAIT_AUDIT'" @click.stop="refuseToReturn()">退回</el-button>
        <el-button v-if="stockData.status == 'WAIT_AUDIT'" @click.stop="agreeToReturn()">同意退货</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="reasonDialog" title="拒绝理由" center width="300px">
      <div style="display: flex;">
        <el-input type="textarea" :rows="4" placeholder="请输入拒绝理由" v-model="refuseReason"></el-input>
      </div>
      <div class="typeButton">
        <el-button
          round
          size="mini"
          @click="reasonDialog = false"
        >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
        <el-button
          round
          type="danger"
          size="mini"
          @click="typeEditOk"
        >&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
      </div>
    </el-dialog>
    <!--endprint-->
  </div>
</template>

<script>
import { refundFormOption } from "@/const/salesCloud/refundFormOption";
import {
  findRefundFormDetail,
  refuseToReturn,
  agreeToReturn
} from "@/api/salesCloud/refundForm";
import { formatterDateToUTC } from "@/util/util";

export default {
  name: "elrefundForm",
  data() {
    return {
      tableOption: refundFormOption, //表格设置属性
      tableData: [], //表格的数据
      stockData: {},
      tableLoading: false,
      reasonDialog: false,
      refuseReason: "",
      // detailId:this.$route.query.id
      detailId: this.$route.params.id
    };
  },
  watch: {},
  created() {
    // console.log(this)
    this.handleList();
  },
  mounted() {},
  methods: {
    agreeToReturn() {
      agreeToReturn(this.detailId).then(res => {
        console.log("同意退货", res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "同意退货成功",
            type: "success"
          });
          this.handleList();
          this.reasonDialog = false;
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    refuseToReturn() {
      this.reasonDialog = true;
    },
    typeEditOk() {
      let params = {
        refusalCause: this.refuseReason
      };
      if (this.refuseReason.replace(/(^\s+)|(^\s+$)/g, "")) {
        refuseToReturn(this.detailId, params).then(res => {
          console.log("退回", res);
          //重置字段
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "退回成功",
              type: "success"
            });
            this.handleList();
            this.reasonDialog = false;
            this.rowId = "";
            this.refuseReason = "";
          } else {
            this.$message({
              showClose: true,
              message: res.message || "服务器出错",
              type: "error"
            });
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "请填写拒绝理由",
          type: "error"
        });
      }
    },
    handleFormatterDateToUTC(data) {
      return formatterDateToUTC(data);
    },
    handleList() {
      // 从sessionStorage获取数据
      // let id = sessionStorage.getItem("key");
      // if(id){
      // this.detailId=id
      // 从sessionStorage删除保存的数据
      // sessionStorage.removeItem("key");
      // }else{
      this.detailId = this.$route.params.id;
      // }
      // let id = this.goodDetailId
      // let mockid = "402883886e692787016e6931d3380000";
      this.tableLoading = true;
      // let parmas = {};
      findRefundFormDetail(this.detailId).then(res => {
        let data = JSON.parse(res.data);
        console.log(res);
        this.stockData = data;
        this.tableData = data.goodsResponseList;
        this.tableLoading = false;
      });
    },
    doPdf() {},
    doPrint() {
      printJS({ printBox: "html", style: "" });
    },
    doPrint() {
      // 保存数据到sessionStorage
      // sessionStorage.setItem("key", this.detailId);

      // 从sessionStorage获取数据
      // var id = sessionStorage.getItem("key");

      // 从sessionStorage删除保存的数据
      // sessionStorage.removeItem("key");

      // 从sessionStorage删除所有保存的数据
      // sessionStorage.clear();

      var printBox = document.getElementById("printBox");
      //拿到打印的区域的html内容
      var newContent = printBox.innerHTML;
      //将旧的页面储存起来，当打印完成后返给给页面。
      var oldContent = document.body.innerHTML;
      //赋值给body
      document.body.innerHTML = newContent;
      //执行window.print打印功能
      window.print();
      //  this.$router.push({
      //     name: "采购出库单",
      //     params: { id:  this.$route.params.id }
      //   });
      // 重新加载页面，以刷新数据。以防打印完之后，页面不能操作的问题
      document.body.innerHTML = oldContent;
      // var id = sessionStorage.getItem("key");
      // this.$route.params.id = id
      window.location.reload(false);
      // 从sessionStorage获取数据
      // console.log(id)
      return false;
    }
  }
};
</script>

<style lang="scss">
@media print {
  #printTitle {
    position: relative;
    left: 50%;
    border: none;
    font-size: 18px;
    margin-left: -37px;
  }
  #noprint {
    display: none;
  }
}
.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.stockwrap {
  background: #fff;
  margin: 1px 10px;
  padding-bottom: 100px !important;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stockMain {
  // border: 1px solid #606266;
  display: flex;
  width: 70%;
  flex-flow: column wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 1px 10px;
  font-size: 14px;
  color: #606266;
  .content {
    border: none;
  }
  .title {
    position: relative;
    left: 50%;
    border: none;
    font-size: 18px;
    margin-left: -37px;
  }
  .btn {
    margin-left: 10%;
    border: none;
    display: flex;
    flex-flow: row nowrap;

    button {
      margin: 0 20px;
    }
  }
  //   .avue-crud{
  //       margin: 0;
  //       width: 90%;
  //   }
}
</style>